// extracted by mini-css-extract-plugin
module.exports = {"paymentMethodSection":"ChoosePaymentMethod_paymentMethodSection__jntp5","paymentByTab":"ChoosePaymentMethod_paymentByTab__c895r","active":"ChoosePaymentMethod_active__7deEr"};